import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './app';
import './styles.css';

/* Register the Workbox service worker from BUNDLED code, not an inline script:
 * the strict CSP (`script-src 'self'`) blocks inline scripts, which would leave
 * the app silently non-offline-capable. See the injectRegister note in
 * vite.config.ts. onNeedRefresh is intentionally a no-op for now — a new SW
 * activates on the next launch, never mid-session (C2). */
registerSW({ immediate: true });

/* Ask WebKit to keep our storage. The outbox and cached content live in
 * IndexedDB/Cache Storage, which iOS may evict under pressure (risk R1). Nothing
 * above the outbox is unrecoverable — the server is authoritative — but a
 * persisted store makes eviction much less likely. */
if ('storage' in navigator && 'persist' in navigator.storage) {
  void navigator.storage.persist();
}

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
